import { render, staticRenderFns } from "./help-btn.vue?vue&type=template&id=7f7db45c&"
import script from "./help-btn.vue?vue&type=script&lang=ts&"
export * from "./help-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports